import DateFilter from '../../../Company/Payroll/Subcomponents/DateFilter';
import ManageButtonsHeader from "./ManageButtonsHeader";
import React from "react";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Software Developer
 * @Email: kpozos@ibl.mx
 *
 * @description
 * DiningAttendanceHead renders the header section for the dining attendance view.
 * It includes filter buttons to switch between views (dining or department),
 * a simple search input, and optionally a date filter when no results are present.
 *
 * @param {Object} props - Component props.
 * @param {string} props.subView - Current subview identifier (e.g., 'dining', 'department').
 * @param {Function} props.handleBtnDinning - Callback to activate dining subview.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @param {Array} props.finalArray - Array containing the final filtered or displayed data.
 * @param {Function} props.setFinalArray - Setter to update the final data array.
 * @param {Function} props.setBodyForExport - Setter to define the body data for export operations.
 * @param {string} props.searchElement - The current string used in the search input.
 * @param {Function} props.setSearchElement - Setter for the search input value.
 * @param {Function} props.setSearch - Callback to execute or trigger a search.
 * @param {Function} props.setSimpleSearch - Setter for simple search value.
 * @param {Function} props.setResults - Setter for the search result list.
 * @param {Array} props.results - The array of current search results.
 * @param {Object} props.option - Table view configuration or mode.
 * @param {number} props.page - Current pagination page number.
 * @param {number} props.rowsPerPage - Number of rows displayed per page.
 * @param {string} props.attendanceStartDate - Start date filter for attendance records.
 * @param {string} props.attendanceEndDate - End date filter for attendance records.
 * @param {string} props.selectedOption - Currently selected filter option.
 * @param {Function} props.setSelectedOption - Setter to update the selected filter option.
 * @param {string|Date} props.selectedDate - Currently selected date in filter.
 * @param {Function} props.setSelectedDate - Setter to update the selected date.
 * @param {Function} [props.setRender] - Optional setter to re-render the view when search changes.
 *
 * @returns {JSX.Element} A header component containing filters, search input, and optional date filters.
 */

const DiningAttendanceHead = (props) => {
    const {
        subView,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        finalArray,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setResults,
        results,
        option,
        rowsPerPage,
        attendanceStartDate,
        attendanceEndDate,
        selectedOption,
        setSelectedOption,
        selectedDate,
        setSelectedDate,
        handleChange,
        setSimpleSearch,
        setSearch
    } = props;

    return (
        <>
            <div className={"col-12 px-0"}>
                <div className='d-flex gap-3'>
                    <ManageButtonsHeader
                        subView={subView}
                        handleBtnDinning={handleBtnDinning}
                        handleBtnSettings={handleBtnSettings}
                        handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                        handleBtnTotalMeals={handleBtnTotalMeals}
                    />
                    <div className='flex-grow-1'>
                        <SearchSimple
                            id={'txt_m_search'}
                            setBodyForExport={setBodyForExport}
                            setSearchResults={setResults}
                            searchResults={results}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            optionTable={option}
                            rowsPerPage={rowsPerPage}
                            attendanceSearchType={selectedOption}
                            setSimpleSearch={setSimpleSearch}
                            setSearch={setSearch}
                            contractorId={null}
                            supplierId={null}
                            attendanceStartDate={attendanceStartDate}
                            attendanceEndDate={attendanceEndDate}
                        />

                    </div>
                </div>
            </div>

            {finalArray?.length === 0 &&
                <div className={"mt-4"}>
                    <DateFilter
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        handleChange={handleChange}
                    />
                </div>
            }

        </>
    );
};

export default DiningAttendanceHead;
